import React, { FunctionComponent } from 'react'
import { Close } from '@mui/icons-material'
import Countdown from 'react-countdown'
import { OfferType, SpecialOffer, SpecialOfferContent } from '@/services/cms-api/home-page-content/types'
import { Divider } from '@mui/material'
import { useLanguage } from '@/context/LanguageContext'
import NewsContentRenderer from '@/components/ui/NewsContentRenderer'
import SocialShare from '@/components/ui/SocialShare'
import useIntl from '@/utils/intl'
import Image from 'next/image'
import { resolveImageUrl } from '@/utils/constants'
import { getSystemEnv } from '@/utils/env'
import DarkIconButton from '@/components/ui/Buttons/SecondaryIconButton'

interface Prop {
  onClose: () => void
  data: SpecialOffer
}

const SpecialOffersContent: FunctionComponent<Prop> = ({ data, onClose }) => {
  const { locale } = useLanguage()
  const { translate } = useIntl()

  if (data === undefined || data === null) {
    return <></>
  }

  const renderer = ({ days, hours, minutes, seconds }: any): any => {
    return (
      <div className='flex gap-2 lg:gap-4'>
        <div className='flex flex-col items-center justify-center'>
          <span className='lg:text-4xl md:text-3xl text-2xl font-extrabold text-textAdditional'>{days}</span>
          <span className='text-textMid text-sm font-medium'>{translate('day')}</span>
        </div>
        <span className='mt-1 text-xl font-extrabold text-textAdditional'>:</span>
        <div className='flex flex-col items-center justify-center'>
          <span className='lg:text-4xl md:text-3xl text-2xl font-extrabold text-textAdditional'>{hours}</span>
          <span className='text-textMid text-sm font-medium'>{translate('hour')}</span>
        </div>
        <span className='mt-1 text-xl font-extrabold text-textAdditional'>:</span>
        <div className='flex flex-col items-center justify-center'>
          <span className='lg:text-4xl md:text-3xl text-2xl font-extrabold text-textAdditional'>{minutes}</span>
          <span className='text-textMid text-sm font-medium'>{translate('minute')}</span>
        </div>
        <span className='mt-1 text-xl font-extrabold text-textAdditional'>:</span>
        <div className='flex flex-col items-center justify-center'>
          <span className='lg:text-4xl md:text-3xl text-2xl font-extrabold text-textAdditional'>{seconds}</span>
          <span className='text-textMid text-sm font-medium'>{translate('second')}</span>
        </div>
        {/* <span>{hours}:{minutes}:{seconds}</span> */}

      </div>

    )
  }

  return (
    <div className='p-4'>
      <div className='flex justify-end'>
        <DarkIconButton type='soft' size='sm' icon={<Close />} onClick={onClose} />
      </div>
      <div className='flex flex-col items-center mt-4'>
        <Image draggable={false} alt='img' width={1000} height={1000} src={resolveImageUrl(data.headerImage)} className='rounded-xl 2xl:w-[997px] xl:w-[900px] lg:w-[803px] md:w-[706px] w-[95vw] aspect-[2/1]' />
        <span className='text-textAdditional font-extrabold xl:text-4xl lg:text-3xl md:text-2xl text-xl mt-10 text-center'>{locale === 'en' ? data.titleEn : data.titleMn}</span>
        <p className='text-textMid mt-4 text-center 2xl:w-[680px] xl:w-[650px] lg:w-[600px] md:w-[560px] text-sm lg:text-base'>{locale === 'en' ? data.descriptionEn : data.descriptionMn}</p>
        <div className='mt-6 backdrop-blur px-8 py-3 rounded-xl bg-white/10 flex flex-col justify-center items-center'>
          <span className='text-textMid text-sm mb-2'>{data.type === 'Promotion'
            ? translate('expire')
            : translate('registrationExpire')}
          </span>
          {
            data.expireDate !== undefined && (
              <Countdown date={data.expireDate} renderer={renderer} />
            )
        }

        </div>
        <div className='lg:p-14 p-8 bg-white/10 mt-16 rounded-xl 2xl:w-[997px] xl:w-[900px] lg:w-[803px] md:w-[706px] w-[95vw] flex flex-col justify-center items-center gap-12'>
          {
            data.content?.map((item: SpecialOfferContent, i: number) => {
              return (
                <NewsContentRenderer
                  key={i} content={item} textColor={data.type === OfferType.Урамшуулал || data.type === OfferType.Бүртгэл
                    ? 'text-white'
                    : 'text-textHigh'}
                />
              )
            })
          }

          <Divider className='bg-white/25 w-full' />
          {
            data.footerMn !== undefined && (
              <span className='text-textAdditional lg:text-2xl text-lg font-bold text-center'>{locale === 'en' ? data.footerEn : data.footerMn}</span>
            )
          }

          <SocialShare
            url={getSystemEnv().DOMAIN + '/news/' + data.id.toString()}
            quote={locale === 'en' ? data.descriptionMn : data.descriptionEn}
            hashtag={locale === 'en' ? data.titleEn : data.titleMn}
          />
        </div>
      </div>
    </div>
  )
}
export default SpecialOffersContent
